// src/firebase.js

// Core SDKs
import { initializeApp } from "firebase/app";
import { getAuth /*, connectAuthEmulator */ } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// --- Config (measurementId present—good) ---
const firebaseConfig = {
  apiKey: "AIzaSyCKVwU2vipNAqNI4gWikyKw_6jWcHU5oNI",
  authDomain: "stt-react-native-app.firebaseapp.com",
  projectId: "stt-react-native-app",
  storageBucket: "stt-react-native-app.appspot.com",
  messagingSenderId: "630721444953",
  appId: "1:630721444953:web:512034aa00b6f2dc498548",
  measurementId: "G-68V6F8L8YW",
};

// --- Initialize app ---
const app = initializeApp(firebaseConfig);

// --- SAFE Analytics init (browser-only, on-demand) ---
if (typeof window !== "undefined") {
  import("firebase/analytics").then(({ getAnalytics, isSupported }) => {
    isSupported()
      .then((ok) => {
        if (ok) {
          try {
            getAnalytics(app); // registers the analytics component
          } catch {
            // measurementId missing or other issue — ignore silently
          }
        }
      })
      .catch(() => {
        // analytics not supported — ignore
      });
  });
}

// --- Other services ---
const auth = getAuth(app);
const db = getFirestore(app);

// Optional emulator if you use it locally
// connectAuthEmulator(auth, "http://127.0.0.1:9099");

// Export what the rest of the app needs
export { app, auth, db };
